import { useState } from 'react';

export default function LeadForm() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '17 99234-2289';

  const handleCopyPhone = () => {
    navigator.clipboard.writeText(phoneNumber.replace(/\s/g, ''));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-teal-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Fale com Nossos Especialistas
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Entre em contato agora mesmo e dê o primeiro passo para conquistar sua casa própria
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 text-center">
          <div className="mb-8">
            <div className="w-20 h-20 mx-auto mb-6 bg-teal-100 rounded-full flex items-center justify-center">
              <i className="ri-phone-fill text-4xl text-teal-600"></i>
            </div>
            <p className="text-gray-600 mb-2">Ligue agora ou envie uma mensagem</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://wa.me/5517992342289`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-500 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-green-600 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Chamar no WhatsApp
            </a>

          </div>

          <p className="mt-8 text-sm text-gray-500">
            Atendimento de segunda a sexta, das 8h às 18h
          </p>
        </div>
      </div>
    </section>
  );
}
